<app-header></app-header>
<div class="text-center">
    <app-email-reg>
    </app-email-reg>
    <app-extra></app-extra>
    <app-footer></app-footer>
</div>